var _circle, _path, _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGood = function SvgGood(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#FFCC4D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#664500",
    d: "M27.841 23.116c-6.432 3.471-13.578 3.41-20.01 0-.794-.426-1.43.305-.953.974 1.985 2.436 5.876 4.69 10.958 4.69s8.973-2.193 10.958-4.69c.476-.67-.159-1.4-.953-.974"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.5,
    cy: 16.5,
    fill: "#664500",
    rx: 2.5,
    ry: 3.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.5,
    cy: 16.5,
    fill: "#664500",
    rx: 2.5,
    ry: 3.5
  })));
};
export default SvgGood;